import clsx from 'clsx';
import styles from './Toggle.module.css';

export interface ToggleProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
  label: string;
  className?: string;
}

/** 50 × 30 switch with a spring knob (`.tog`). */
export function Toggle({ checked, onChange, label, className }: ToggleProps) {
  return (
    <button
      type="button"
      role="switch"
      aria-checked={checked}
      aria-label={label}
      className={clsx(styles.tog, checked && styles.on, className)}
      onClick={() => onChange(!checked)}
    />
  );
}
